import { checkiOS } from "./checkIOS";
import { safePlay } from "./safe-play";

export function fadeOutBgAudio(
  bgSound: HTMLAudioElement,
  soundToPlay?: HTMLAudioElement
) {
  if (checkiOS()) {
    bgSound.pause();
    if (soundToPlay) {
      safePlay(soundToPlay);
    }
  } else {
    const fadeAudio = setInterval(function () {
      if (bgSound.volume <= 0.2) {
        bgSound.volume = 0;
        bgSound.currentTime = 0;
        bgSound.pause();
        if (soundToPlay) {
          safePlay(soundToPlay);
        }
        clearInterval(fadeAudio);
      } else if (bgSound.volume !== 0.0) {
        bgSound.volume -= 0.1;
      }
    }, 50);
  }
}
